<template>
  <path
    id="youtube"
    d="M15.90375,11.5260938 L9.575625,8.01046875 C9.358125,7.88953125 9.09234375,7.8928125 8.87765625,8.01890625 C8.66296875,8.14546875 8.53125,8.37609375 8.53125,8.625 L8.53125,15.7734375 C8.53125,16.0242188 8.66484375,16.25625 8.881875,16.381875 C9.103125,16.5098438 9.37125,16.505625 9.58453125,16.3832813 L15.9126563,12.7504688 C16.1325,12.624375 16.2675,12.3890625 16.265625,12.1354688 C16.26375,11.881875 16.1254687,11.6489063 15.90375,11.5260938 Z M9.9375,14.5589063 L9.9375,9.81984375 L14.1328125,12.1504688 L9.9375,14.5589063 Z M20.484375,3 C22.423125,3 24,4.57734375 24,6.515625 L24,17.765625 C24,19.7039062 22.423125,21.28125 20.484375,21.28125 L3.515625,21.28125 C1.576875,21.28125 0,19.7039062 0,17.765625 L0,6.515625 C0,4.57734375 1.576875,3 3.515625,3 L20.484375,3 Z M22.59375,17.765625 L22.59375,6.515625 C22.59375,5.35265625 21.6473438,4.40625 20.484375,4.40625 L3.515625,4.40625 C2.35265625,4.40625 1.40625,5.35265625 1.40625,6.515625 L1.40625,17.765625 C1.40625,18.9285937 2.35265625,19.875 3.515625,19.875 L20.484375,19.875 C21.6473438,19.875 22.59375,18.9285937 22.59375,17.765625 Z"
    :fill="iconColor"
  />
</template>

<script>
export default {
    name: 'YoutubeIcon',
    props: {
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    }
};
</script>

<style scoped></style>
